<template>
    <div class="d-flex justify-content-center container text-start mt-3">
        <div class="card" style="width: 500px">
            <div class="card-header">
                <b style="font-size: 20px">APPRAISAL RESULT</b>
            </div>
            <div class="ms-4 mt-3">
                <p>Name: {{ candidate.name }}</p>
                <p>File No.: {{ candidate.fileNum }}</p>
            </div>
            <div class="p-1">
                <table class="table table-striped">
                    <tbody>
                        <tr>
                            <th></th>
                            <th>ITEM</th>
                            <th>SCORE</th>
                        </tr>
                        <tr>
                            <th></th>
                            <td>Qualifications</td>
                            <td>
                                <div>
                                    {{ qualificationScore }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <td>Publications and Other Productive Works</td>
                            <td>
                                <div>
                                    {{ publicationsScore }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <td>Teaching and Professional Experience</td>
                            <td>
                                <div>
                                    {{ teachingScore }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <td>Academic Leadership</td>
                            <td>
                                <div>
                                    {{ academicLeadershipScore }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <td>Conferences and Learned Society Activities</td>
                            <td>
                                <div>
                                    {{ conferenceScore }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <td>University Administration</td>
                            <td>
                                <div>
                                    {{ uniAdminScore }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <td>Community Service</td>
                            <td>
                                <div>
                                    {{ communityServiceScore }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <td>Bonus</td>
                            <td>
                                <div>
                                    {{ candidate.bonus }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <th class="text-end">TOTAL</th>
                            <th>
                                <div>
                                    {{ total }}
                                </div>
                            </th>
                        </tr>
                    </tbody>
                </table>
                <div class="m-4">
                    <div>
                        <p><b>General comments:</b></p>
                    </div>
                    <div style="margin-top: -20px;">
                        <textarea v-model="comments" type="text" class="form-control" rows="5"></textarea>
                    </div>
                </div>
                <div class="m-4">
                    <p>
                        <b>Do you approve the candidate for promotion?</b>
                    </p>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="radioDefault" id="radioDefault1" v-model="approval" :value=true>
                        <label class="form-check-label" for="radioDefault1">
                            Yes, I approve the candidate for promotion.
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="radioDefault" id="radioDefault2" v-model="approval" :value=false>
                        <label class="form-check-label" for="radioDefault2">
                            No, I do not approve the candidate for promotion.
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center">
        <div class="my-3 ms-3">
            <router-link :to="'/candidate/' + candidate._id + '?token=' + $route.query.token">
                <button type="button" class="btn btn-success">Back to Scoring</button>
            </router-link>
        </div>
        &nbsp;&nbsp;
        <div class="my-3" v-if="certifierIsAssessor">
            <router-link :to="'/assessor' + '?token=' + $route.query.token">
                <button type="button" class="btn btn-success">Back to Assessor Portal</button>
            </router-link>
        </div>
        &nbsp;&nbsp;
        <div class="my-3 me-3">
            <button @click="submitAssessment()" type="button" class="btn btn-success">Submit Assessment</button>
        </div>
    </div>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'result',
    emits: ['toggleLoader', 'setSection'],
    data() {
        return {
            candidate: {
                academicStaff: {
                    books: [],
                    majorWorks: [],
                    minorWorks: [],
                    bookChapters: [],
                    journalArticles: [],
                    conferenceArticles: [],
                    technicalReports: [],
                    bookEditors: [],
                    otherBooks: [],
                    sessionsTaught: 0,
                    teachingScore: 0,
                    pgTeachings: [],
                    ugTeachings: [],
                    professionalExperiences: [],
                    degreePrograms: [],
                    seminarWorkshops: [],
                    pgSupervisions: [],
                    ugSupervisions: [],
                    conferences: [],
                    universityAdmins: [],
                    otherServices: [],
                },
                communityServices: [],
                professionalBodies: [],
                committeeMemberships: [],
            },
            comments: '',
            approval: false
        }
    },
    created() {
        this.setData()
    },
    computed: {
        certifierIsAssessor() {
            if (this.$route.query.token && this.$route.query.token != 'undefined') {
                var payload = this.$route.query.token.split('.')[1]
                return JSON.parse(atob(payload)).certifier == 'assessor'
            } else {
                return false
            }
        },
        certifierIsExternal() {
            if (this.$route.query.token && this.$route.query.token != 'undefined') {
                var payload = this.$route.query.token.split('.')[1]
                return JSON.parse(atob(payload)).certifier == 'external'
            } else {
                return false
            }
        },
        qualificationScore() {
            if (this.candidate.doctorate && this.candidate.masters) {
                var qualificationTotal = this.candidate.doctorate.score + this.candidate.masters.score

                if (this.candidate.presentStatus == 'Assistant Lecturer' && qualificationTotal > 60) {
                    qualificationTotal = 60
                } else if (this.candidate.presentStatus == 'Lecturer II' && qualificationTotal > 30) {
                    qualificationTotal = 30
                } else if (this.candidate.presentStatus == 'Lecturer I' && qualificationTotal > 10) {
                    qualificationTotal = 10
                } else if (this.candidate.presentStatus == 'Senior Lecturer' && qualificationTotal > 5) {
                    qualificationTotal = 5
                } else if (this.candidate.presentStatus == 'Reader' && qualificationTotal > 5) {
                    qualificationTotal = 5
                }

                return qualificationTotal
            }

            return 0
        },
        publicationsScore() {
            var [
                publicationSum,
                bookSum,
                otherBookSum,
                workSum,
                bookChapterSum,
                journalArticleSum,
                conferenceArticleSum,
                technicalReportSum,
                bookEditorSum
            ] = Array(9).fill(0);

            bookSum = this.sumArray(this.candidate.academicStaff.books, bookSum) + this.sumArray(this.candidate.academicStaff.otherBooks, otherBookSum);
            bookSum = bookSum > 6 ? 6 : bookSum;

            workSum = this.sumArray(this.candidate.academicStaff.majorWorks, workSum) + this.sumArray(this.candidate.academicStaff.minorWorks, workSum);
            workSum = workSum > 4 ? 4 : workSum;

            bookChapterSum = this.sumArray(this.candidate.academicStaff.bookChapters, bookChapterSum);
            bookChapterSum = bookChapterSum > 4 ? 4 : bookChapterSum

            journalArticleSum = this.sumArray(this.candidate.academicStaff.journalArticles, journalArticleSum);

            conferenceArticleSum = this.sumArray(this.candidate.academicStaff.conferenceArticles, conferenceArticleSum)
            conferenceArticleSum = conferenceArticleSum > 4 ? 4 : conferenceArticleSum;

            technicalReportSum = this.sumArray(this.candidate.academicStaff.technicalReports, technicalReportSum);
            technicalReportSum = technicalReportSum > 4 ? 4 : technicalReportSum;

            bookEditorSum = this.sumArray(this.candidate.academicStaff.bookEditors, bookEditorSum);
            bookEditorSum = bookEditorSum > 2 ? 2 : bookEditorSum;

            publicationSum = bookSum + workSum + bookChapterSum + journalArticleSum + conferenceArticleSum + technicalReportSum + bookEditorSum;

            if (this.candidate.presentStatus == 'Assistant Lecturer') {
                publicationSum = publicationSum > 10 ? 10 : publicationSum
            } else if (this.candidate.presentStatus == 'Lecturer II') {
                publicationSum = publicationSum > 25 ? 25 : publicationSum
            } else if (this.candidate.presentStatus == 'Lecturer I') {
                publicationSum = publicationSum > 30 ? 30 : publicationSum
            } else if (this.candidate.presentStatus == 'Senior Lecturer') {
                publicationSum = publicationSum > 55 ? 55 : publicationSum
            } else if (this.candidate.presentStatus == 'Reader') {
                publicationSum = publicationSum > 60 ? 60 : publicationSum
            }

            return publicationSum
        },
        teachingScore() {

            var teachingSum = 0;

            teachingSum = this.candidate.academicStaff.sessionsTaught * this.candidate.academicStaff.teachingScore;

            if (this.candidate.presentStatus == 'Assistant Lecturer') {
                teachingSum = teachingSum > 15 ? 15 : teachingSum
            } else if (this.candidate.presentStatus == 'Lecturer II') {
                teachingSum = teachingSum > 30 ? 30 : teachingSum
            } else if (this.candidate.presentStatus == 'Lecturer I') {
                teachingSum = teachingSum > 40 ? 40 : teachingSum
            } else if (this.candidate.presentStatus == 'Senior Lecturer') {
                teachingSum = teachingSum > 20 ? 20 : teachingSum
            } else if (this.candidate.presentStatus == 'Reader') {
                teachingSum = teachingSum > 15 ? 15 : teachingSum
            }

            return teachingSum
        },
        academicLeadershipScore() {
            var [
                leadershipSum,
                pgSupervisionSum,
                ugSupervisionSum
            ] = Array(3).fill(0);

            pgSupervisionSum = this.sumArray(this.candidate.academicStaff.pgSupervisions, pgSupervisionSum);
            pgSupervisionSum = pgSupervisionSum > 4 ? 4 : pgSupervisionSum;

            ugSupervisionSum = this.sumArray(this.candidate.academicStaff.ugSupervisions, ugSupervisionSum);
            ugSupervisionSum = ugSupervisionSum > 4 ? 4 : ugSupervisionSum;

            leadershipSum = pgSupervisionSum + ugSupervisionSum;

            if (this.candidate.presentStatus == 'Assistant Lecturer') {
                leadershipSum = 0
            } else if (this.candidate.presentStatus == 'Lecturer II') {
                leadershipSum = 0
            } else if (this.candidate.presentStatus == 'Lecturer I') {
                leadershipSum = 0
            } else if (this.candidate.presentStatus == 'Senior Lecturer') {
                leadershipSum = leadershipSum > 5 ? 5 : leadershipSum
            } else if (this.candidate.presentStatus == 'Reader') {
                leadershipSum = leadershipSum > 10 ? 10 : leadershipSum
            }

            return leadershipSum
        },
        conferenceScore() {
            var [conferenceProfessionalSum, conferenceSum, professionalBodySum] = [0, 0, 0]

            conferenceSum = this.sumArray(this.candidate.academicStaff.conferences, conferenceSum);
            conferenceSum = conferenceSum > 3 ? 3 : conferenceSum;

            professionalBodySum = this.sumArray(this.candidate.professionalBodies, professionalBodySum);
            professionalBodySum = professionalBodySum > 3 ? 3 : professionalBodySum;

            conferenceProfessionalSum = conferenceSum + professionalBodySum;

            if (
                this.candidate.presentStatus == 'Assistant Lecturer' ||
                this.candidate.presentStatus == 'Lecturer II' ||
                this.candidate.presentStatus == 'Lecturer I' ||
                this.candidate.presentStatus == 'Senior Lecturer'
            ) {
                conferenceProfessionalSum = conferenceProfessionalSum > 5 ? 5 : conferenceProfessionalSum
            } else if (this.candidate.presentStatus == 'Reader') {
                conferenceProfessionalSum = conferenceProfessionalSum > 3 ? 3 : conferenceProfessionalSum
            }

            return conferenceProfessionalSum
        },
        uniAdminScore() {
            var [uniAdminTotal, uniAdminSum, committeeMemberSum, otherSum] = Array(4).fill(0);

            uniAdminSum = this.multiplyArray(this.candidate.academicStaff.universityAdmins, uniAdminSum);
            uniAdminSum = uniAdminSum > 10 ? 10 : uniAdminSum;

            committeeMemberSum = this.multiplyArray(this.candidate.committeeMemberships, committeeMemberSum);
            committeeMemberSum = committeeMemberSum > 2 ? 2 : committeeMemberSum;

            otherSum = this.multiplyArray(this.candidate.academicStaff.otherServices, otherSum);
            otherSum = otherSum > 2 ? 2 : otherSum;

            uniAdminTotal = uniAdminSum + committeeMemberSum + otherSum;

            uniAdminTotal = uniAdminTotal > 5 ? 5 : uniAdminTotal

            return uniAdminTotal
        },
        communityServiceScore() {
            var communityServiceSum = 0;

            communityServiceSum = this.multiplyArray(this.candidate.communityServices, communityServiceSum);
            communityServiceSum = communityServiceSum > 6 ? 6 : communityServiceSum;

            if (
                this.candidate.presentStatus == 'Assistant Lecturer' ||
                this.candidate.presentStatus == 'Lecturer II' ||
                this.candidate.presentStatus == 'Lecturer I' ||
                this.candidate.presentStatus == 'Senior Lecturer'
            ) {
                communityServiceSum = communityServiceSum > 5 ? 5 : communityServiceSum
            } else if (this.candidate.presentStatus == 'Reader') {
                communityServiceSum = communityServiceSum > 2 ? 2 : communityServiceSum
            }

            return communityServiceSum

        },
        total() {
            return this.qualificationScore + this.publicationsScore + this.teachingScore + this.academicLeadershipScore + this.conferenceScore + this.uniAdminScore + this.communityServiceScore + this.candidate.bonus;
        }
    },
    methods: {
        async setData() {
            this.$emit('toggleLoader');

            const candidate = await DataService.getCandidate(this.$route.params.id);
            
            if (candidate) {
                if (this.certifierIsAssessor) {
                    this.candidate = candidate.submittedDoc;
                } else if (this.certifierIsExternal) {
                    var payload = this.$route.query.token.split('.')[1]
                    var email = JSON.parse(atob(payload)).email

                    if (candidate.presentStatus == 'Senior Lecturer') {
                        for (var i=0; i < candidate.readerExternalAssessors.length; i++) {
                            if (candidate.readerExternalAssessors[i].email == email) {
                                this.candidate = candidate.readerExternalAssessors[i].candidate
                            }
                        }
                    } else if (candidate.presentStatus == 'Reader') {
                        for (var i=0; i < candidate.profExternalAssessors.length; i++) {
                            if (candidate.profExternalAssessors[i].email == email) {
                                this.candidate = candidate.profExternalAssessors[i].candidate
                            }
                        }
                    }
                }
            }

            this.$emit('toggleLoader');
        },
        sumArray(array, sumVar) {
            for (var i = 0; i < array.length; i++) {
                sumVar += array[i].score
            }
            return sumVar
        },
        multiplyArray(array, sumVar) {
            for (var j = 0; j < array.length; j++) {
                sumVar += (array[j].sessionNum * array[j].score)
            }
            return sumVar
        },
        async submitAssessment() {
            this.$emit('toggleLoader');

            var details = {
                candidateId: this.$route.params.id,
                comments: this.comments,
                token: this.$route.query.token,
                approval: this.approval,
                total: this.total
            }

            const candidate = await DataService.submitAssessment(details);
            
            if (candidate) {
                if (this.certifierIsAssessor) {
                    this.candidate = candidate.submittedDoc;
                } else if (this.certifierIsExternal) {
                    var payload = this.$route.query.token.split('.')[1]
                    var email = JSON.parse(atob(payload)).email

                    if (candidate.presentStatus == 'Senior Lecturer') {
                        for (var i=0; i < candidate.readerExternalAssessors.length; i++) {
                            if (candidate.readerExternalAssessors[i].email == email) {
                                this.candidate = candidate.readerExternalAssessors[i].candidate
                            }
                        }
                    } else if (candidate.presentStatus == 'Reader') {
                        for (var i=0; i < candidate.profExternalAssessors.length; i++) {
                            if (candidate.profExternalAssessors[i].email == email) {
                                this.candidate = candidate.profExternalAssessors[i].candidate
                            }
                        }
                    }
                } 
            }

            this.$emit('toggleLoader');
        }
    }
}
</script>